<template>
  <form class="p-2" @submit.prevent="handleFlightMode">
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      loader="bars"
    ></loading>

    <modal-container :show="show" @close="onCancel">
      <template slot="header">
        <h4 class="mb-0 text-capitalize">{{ $t("turn_on_flight_mode") }}</h4>
      </template>

      <template slot="body">
        <div style="min-height: 20rem">
          <div class="flight-type">
            <label>Type</label>
            <select v-model="selectedFlightModeType" class="">
              <option value="" disabled selected>Select</option>
              <option
                :value="option.value"
                v-for="option in flightModeTypeOptions"
                :key="option.value"
              >
                {{ option.label }}
              </option>
            </select>
          </div>
          <div v-if="selectedFlightModeType === 'manual'">
            <div class="align-items-center d-flex col-gap-1 mb-2">
              <div class="form-group w-100">
                <label for="into_flight_date">
                  {{ $t("into_flight_date") }}
                </label>
                <input
                  type="date"
                  v-model="into_flight_date"
                  class="form-control text-uppercase"
                  required
                  id="into_flight_date"
                  :min="new Date().toISOString().slice(0, 10)"
                />
              </div>

              <div class="form-group w-100">
                <label for="into_flight_time">
                  {{ $t("into_flight_time") }}
                </label>
                <input
                  type="time"
                  v-model="into_flight_time"
                  class="form-control"
                  required
                  id="into_flight_time"
                />
              </div>
            </div>

            <div class="align-items-center d-flex col-gap-1">
              <div class="form-group w-100">
                <label for="out_flight_date">
                  {{ $t("out_flight_date") }}
                </label>
                <input
                  type="date"
                  v-model="out_flight_date"
                  class="form-control text-uppercase"
                  required
                  id="out_flight_date"
                  :min="into_flight_date"
                />
              </div>

              <div class="form-group w-100">
                <label for="out_flight_time">
                  {{ $t("out_flight_time") }}
                </label>
                <input
                  type="time"
                  v-model="out_flight_time"
                  class="form-control"
                  required
                  id="out_flight_time"
                />
              </div>
            </div>
          </div>
          <div v-if="selectedFlightModeType === 'direct'">
            <div class="align-items-center d-flex col-gap-1 mb-2">
              <div class="form-group w-100">
                <label for="into_flight_date">
                  {{ $t("airline_carrier") }}
                </label>
                <select v-model="personalMode.carrierCode" class="form-control">
                  <option value="selected" selected disabled>
                    Select Airline
                  </option>

                  <option
                    :value="carrierCode.code"
                    v-for="carrierCode in carrierCodes"
                    :key="carrierCode.code"
                  >
                    {{ carrierCode.name }}
                  </option>
                </select>
              </div>

              <div class="form-group w-100">
                <label for="into_flight_time">
                  {{ $t("flight_number") }}
                </label>
                <input
                  type="text"
                  :value="personalMode.flightNumber"
                  @input="debouncedUpdateFlightNumber($event.target.value)"
                  class="form-control"
                  required
                  id="into_flight_time"
                />
              </div>
            </div>

            <div class="d-flex col-gap-1">
              <div class="form-group w-100">
                <label for="out_flight_date">
                  {{ $t("schedule_departure_date") }}
                </label>
                <input
                  type="date"
                  v-model="personalMode.scheduledDepartureDate"
                  class="form-control text-uppercase"
                  required
                  id="out_flight_date"
                  :min="new Date().toISOString().slice(0, 10)"
                />
              </div>

              <div class="form-group w-100">
                <label for="out_flight_time">
                  {{ $t("flight_schedule") }}
                </label>
                <select v-model="personalMode.schedule" class="form-control">
                  <option value="selected" disabled selected>
                    Select flight schedule
                  </option>
                  <option
                    :value="option.value"
                    v-for="option in flightSchedules"
                    :key="option.value"
                  >
                    {{ option.label }}
                  </option>
                </select>
                <p v-if="showError" class="error font-10">
                  No flight scheduled for
                  {{ personalMode.scheduledDepartureDate }}
                </p>
              </div>
            </div>
          </div>
          <div v-if="selectedFlightModeType === 'shipment'">
            <div class="align-items-center d-flex col-gap-1 mb-2">
              <div class="form-group w-100">
                <label for="into_flight_date">
                  {{ $t("shipment_carrier") }}
                </label>
                <select
                  v-model="shimentMode.shipmentCarrier"
                  class="form-control"
                >
                  <option value="selected" selected>Select</option>
                </select>
              </div>

              <div class="form-group w-100">
                <label for="into_flight_time">
                  {{ $t("tracking_number") }}
                </label>
                <input
                  type="text"
                  v-model="shimentMode.trackingNumber"
                  class="form-control"
                  required
                  id="into_flight_time"
                />
              </div>
            </div>
          </div>
        </div>
      </template>
      <template slot="footer">
        <div style="display: flex; justify-content: end">
          <button
            type="submit"
            class="btn btn-primary text-capitalize"
            :disabled="disableTurnOn"
          >
            {{ $t("turn_on") }}
          </button>
        </div>
      </template>
    </modal-container>
  </form>
</template>

<script>
import ModalContainer from "../../components/ModalContainer.vue";
import { mapActions } from "vuex";
import carrierCodes from "./../../assets/json/airline.json";
import Loading from "vue-loading-overlay";
// import scheduleOptions from "./../../assets/json/schedule.json";
import "vue-loading-overlay/dist/vue-loading.css";
import debounce from "lodash.debounce";
import moment from "moment";

export default {
  components: {
    ModalContainer,
    Loading,
  },
  props: {
    show: Boolean,
    onCancel: Function,
  },
  name: "FlightModeModal",
  data() {
    return {
      into_flight_date: "",
      into_flight_time: "",
      out_flight_date: "",
      out_flight_time: "",
      isLoading: false,
      fullPage: true,
      selectedFlightModeType: "",
      carrierCodes,
      personalMode: {
        flightNumber: null,
        carrierCode: "selected",
        scheduledDepartureDate: "",
        schedule: "selected",
      },
      flightScheduleOptions: [],
      shimentMode: {
        shipmentCarrier: "selected",
        trackingNumber: "27DAKJ128",
      },
      flightModeTypeOptions: [
        {
          label: "Manual",
          value: "manual",
        },
        {
          label: "Automatic",
          value: "direct",
        },
        // {
        //   label: "Shipment",
        //   value: "shipment",
        // },
      ],
      scheduleOptions: [],
      showError: false,
    };
  },
  computed: {
    flightSchedules() {
      const flightSchedule = this.scheduleOptions.map(
        ({ flightDesignator, flightPoints }) => {
          const departureTimestamp = flightPoints[0].departure.timings[0].value; // "2025-03-03T07:00+03:00"
          const flightTime = moment
            .parseZone(departureTimestamp)
            .format("HH:mm");
          return {
            label: `${flightDesignator.carrierCode} ${flightTime}`,
            value: {
              startDate: flightPoints[0].departure.timings[0].value,
              endDate: flightPoints[1].arrival.timings[0].value,
            },
          };
        }
      );
      return flightSchedule || [];
    },
    disableTurnOn() {
      return (
        this.selectedFlightModeType === "direct" &&
        (this.scheduleOptions.length === 0 ||
          this.showError ||
          !this.personalMode.schedule.endDate)
      );
    },
  },
  created() {
    this.debouncedUpdateFlightNumber = debounce(this.updateFlightNumber, 500);
  },
  watch: {
    "personalMode.flightNumber": function (newVal) {
      this.debouncedUpdateFlightNumber(+newVal);
    },
    "personalMode.carrierCode": function (newVal) {
      if (newVal !== "selected") {
        this.checkAndFetchSchedule();
      }
    },
    "personalMode.scheduledDepartureDate": function (newVal) {
      if (newVal) {
        this.checkAndFetchSchedule();
      }
    },
  },
  methods: {
    ...mapActions([
      "updateFlightMode",
      "updateFlightModeDirect",
      "fetchFlightSchedule",
    ]),

    handleFlightMode() {
      if (this.selectedFlightModeType === "manual") {
        const payload = {
          startDate: new Date(
            `${this.into_flight_date}T${this.into_flight_time}`
          ),
          endDate: new Date(`${this.out_flight_date}T${this.out_flight_time}`),
          enableFlightMode: true,
        };

        this.isLoading = true;
        this.updateFlightMode({
          device_id: this.$route.params.device_id,
          flightMode: payload,
        })
          .then(() => {
            this.isLoading = false;
            this.$emit("flightMode");
          })
          .catch((error) => {
            this.isLoading = false;
            console.error("Error updating flight mode", error);
          });
      }
      if (this.selectedFlightModeType === "direct") {
        const payload = {
          ...this.personalMode,
          scheduledDepartureDate: new Date(
            `${this.personalMode.scheduledDepartureDate}`
          ),
          // carrierCode: "UR",
          // flightNumber: 900,
          // scheduledDepartureDate: "2025-03-03",
          // schedule: this.personalMode.schedule,
          enableFlightMode: true,
        };
        this.isLoading = true;
        this.updateFlightModeDirect({
          device_id: this.$route.params.device_id,
          flightMode: payload,
        })
          .then(() => {
            this.isLoading = false;
            this.$emit("flightMode");
          })
          .catch((error) => {
            this.isLoading = false;
            console.error("Error updating flight mode", error);
          });
      }
    },
    formatDepartureSchedule() {
      if (
        !this.personalMode.carrierCode ||
        this.personalMode.carrierCode === "selected" ||
        this.scheduleOptions.length === 0
      ) {
        return;
      } else {
        this.flightScheduleOptions = this.scheduleOptions.map(
          ({ flightDesignator, flightPoints }) => {
            return {
              label: `${flightDesignator.carrierCode} ${flightPoints[0].departure.timings.value}`,
              value: `${flightDesignator.carrierCode} ${flightPoints[0].departure.timings.value}`,
            };
          }
        );
      }
    },
    checkAndFetchSchedule() {
      this.scheduleOptions = [];
      const { carrierCode, flightNumber, scheduledDepartureDate } =
        this.personalMode;
      if (carrierCode && flightNumber && scheduledDepartureDate) {
        this.isLoading = true;
        this.fetchFlightSchedule({
          device_id: this.$route.params.device_id,
          carrierCode,
          flightNumber,
          scheduledDepartureDate,
          // carrierCode: "UR",
          // flightNumber: 900,
          // scheduledDepartureDate: "2025-03-03",
        })
          .then((res) => {
            this.isLoading = false;
            if (res.data.payload.data.length === 0) {
              this.showError = true;
            } else {
              this.showError = false;
            }
            this.scheduleOptions = res.data.payload.data;
          })
          .catch(() => {
            // this.showError = true;
            this.isLoading = false;
          });
      }
    },
    updateFlightNumber(value) {
      this.personalMode.flightNumber = value;
      this.checkAndFetchSchedule();
    },
  },
};
</script>

<style scoped>
.flight-type {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-bottom: 30px;
}

.flight-type select {
  width: 100%;
  padding: 0.5rem;
  height: 45px;
  /* border-radius: 0.25rem;
  border: 1px solid #ced4da; */
}
</style>
